export const formEducationValues = (data = {}) => ({
    sd_id: data?.sd_id ?? "",
    smp_id: data?.smp_id ?? "",
    sma_id: data?.sma_id ?? "",
    academy_id: data?.academy_id ?? "",
    university_id: data?.university_id ?? "",
    magister_id: data?.magister_id ?? "",
    doctoral_id: data?.doctoral_id ?? "",
  });
  